<template>
<div class="card">
  <div class="search-box">
    <span class="header">供应商信息</span>
    <div class="item">
      <span><label>供应商账号名：</label>{{supplierInfo.alias}}</span>
      <span><label>供应商账号：</label>{{supplierInfo.account}}</span>
    </div>
    <div class="item"><label>待结算金额：</label>{{supplierInfo.postpaidAccountBalance}}&nbsp元</div>
  </div>
  <div class="list" style="background:rgba(255,255,255,1); padding:24px">
    <a-tabs v-model="settlement.tag" type="card" @change="callback" >
      <a-tab-pane :key="0" tab="待核帐">
      </a-tab-pane>
      <a-tab-pane :key="1" tab="发票核验">
      </a-tab-pane>
      <a-tab-pane :key="2" tab="待上传付款凭证">
      </a-tab-pane>
      <a-tab-pane :key="3" tab="已结算">
      </a-tab-pane>
      <a-tab-pane :key="4" tab="核账不通过">
      </a-tab-pane>
      <a-tab-pane :key="5" tab="发票核验不通过">
      </a-tab-pane>
    </a-tabs>
    <settle-table :data="data" :pagination="pagination"/>
  </div>
</div>
</template>
<script>
import settleTable from './settleTable'
import {mapState} from 'vuex'
export default {
  components:{settleTable},
  data() {
    return {
      data:[],
      supplierInfo:{},
      pagination: {
        total:0,
        current:1,
        pageSize:10,
        onChange: page => {
          this.pagination.current = page;
          this.getdata && this.getdata();
        },
      },
    };
  },
   computed:{
    ...mapState(['settlement'])
  },
  activated(){
      let meta = this.$route.meta;
      if (!meta.keepAlive) {
        this.pagination.current = 1;
        this.settlement.tag = 0;
        this.getdata();
      }
  }, 
  beforeRouteEnter(to,from,next){
      if(from.name !== 'settlement-detail'){//不是从detail页面过来的，需要刷新
          to.meta.keepAlive = false;
      }else{
        to.meta.keepAlive = true;
      }
      next()
  },
  beforeRouteLeave(to,from,next){
    if(to.name !== 'settlement-detail') {//不去详情页面时，将缓存的listData数组清空
        this.data = []
    }
    next()
  },
  methods:{
    callback(){
      this.pagination.current = 1;
      this.getdata();
    },
    getdata(){
      const status = [[10],[20,30],[40],[50],[15],[35]];
      let statusSet = status[this.settlement.tag];
      let params = {
        pageNum : this.pagination.current,
        supplierId:this.$route.query.id,
        statusSet:statusSet,
      };
      this.$http.post('settleApply/queryRecordList',params).then(res=>{
        this.supplierInfo = res.data;
        this.data = res.rows;
        this.pagination.total = res.count;
      })
    },
  }
};
</script>
<style lang="less" scoped>
.card{
  margin:0 24px;
}
.search-box{
  background:rgba(255,255,255,1);
  label{
    display:inline-block;
    width: 98px;
    text-align: right;
  }
  .header{
    font-size:16px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(0,0,0,0.85);
    line-height:24px;
  }
  span{
      display: inline-block;
      padding: 8px 0 ;
    }
  .item{
    span{
      padding-right:180px;
    }
  }
}
.ant-list-split .ant-list-item {
    border: 1px solid #e8e8e8;
    // border-bottom: 0;
    margin-bottom: 12px;
}
/deep/.ant-list-split .ant-list-header {
    /* border-bottom: 1px solid #e8e8e8; */
    margin-bottom: 12px;
    background-color: #FAFAFA;
}
</style>
